import { render, staticRenderFns } from "./MdMemo.vue?vue&type=template&id=c1d2e302&"
import script from "./MdMemo.vue?vue&type=script&lang=js&"
export * from "./MdMemo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports